/**
 * Below this width the header folds its tools and desktop actions into the
 * right-hand menu. Keep in step with the 767px media queries in its CSS modules.
 */
export const COMPACT_HEADER_QUERY = '(max-width: 767px)';
